import type { ILanguageDto, ISiteDto } from '../../model/interface';
import type { IWorkspaceDB } from '../../db/interface';

function SiteSupportedLanguages(db: IWorkspaceDB, site?: ISiteDto): Promise<Array<ILanguageDto>> {
    return new Promise(async function (resolve, reject) {
        try {
            const siteLookup = site ?? (await db.first('ISiteDto'));

            const siteSupportedLanguages = await db.all('ISiteSupportedLanguageDto');

            const languageIds = siteSupportedLanguages
                .filter(ssl => ssl.siteId === siteLookup.id)
                .map(ssl => ssl.languageId);

            const languages = await Promise.all(languageIds.map(id => db.get('ILanguageDto', id)));

            resolve(languages);
        } catch (error) {
            reject(error);
        }
    });
}

const module = {
    SiteSupportedLanguages,
};

export default module;
